@let expandedUtilitiesAppIds = store.expandedUtilitiesAppIdsSg();
@let navbarIsExpanded = store.expandedSg();
@let app = appSg();

<!-- Utilities Toggle -->
<div
  class="atn-navbar-app-utilities__toggle"
  (click)="store.toggleUtilitiesExpanded(app.id)"
>
  <span class="atn-navbar-app-utilities__name">
    Utilities
    <span class="atn-navbar-app-utilities__icon-wrapper">
      <i
        class="atn-navbar-app-utilities__icon atn-icon atn-angle-{{
          expandedUtilitiesAppIds.has(app.id) ? 'down' : 'left'
        }} atn-light"
      ></i>
    </span>
  </span>
</div>

<!-- Utility Pages -->
<div
  class="atn-navbar-app-utilities__pages"
  [class.atn-navbar-app-utilities__pages--hidden]="
    !expandedUtilitiesAppIds.has(app.id) || !navbarIsExpanded
  "
>
  @for (appPage of app.pages; track appPage.id) {
    @if (appPage.display && !appPage.display.isMain) {
      <a
        class="atn-navbar-app-utilities__item"
        [class.atn-navbar-app-utilities__item--active]="
          meFeature.contexts.selectors.isCurrentlyOnAppPage(appPage).asSignal()
        "
        [atnPlatformNavigationLink]="
          meFeature.contexts.selectors
            .getUrlForLink({ goto: { navigationId: appPage.alias } }, { app })
            .asSignal()
        "
      >
        {{ appPage.name }}
      </a>
    }
  }
</div>
